(() => {
  const V = window.Vernika = window.Vernika || {};
  const t = key => V.strings && V.strings[key] || key;
  V.store = {
    get(key, fallback) {
      try {
        const raw = localStorage.getItem(key);
        return raw === null ? fallback : JSON.parse(raw);
      } catch {
        return fallback;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {}
    }
  };
  V.money = cents => {
    const currency = window.Shopify && Shopify.currency && Shopify.currency.active || "INR";
    const value = Number(cents) / 100;
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(value);
  };
  V.toast = (message, {tone: tone = "default", action: action, duration: duration = 3800} = {}) => {
    const region = document.getElementById("toasts");
    if (!region) return;
    const toast = document.createElement("div");
    toast.className = `toast toast--${tone}`;
    const dot = document.createElement("span");
    dot.className = "toast__dot";
    const text = document.createElement("span");
    text.className = "toast__message";
    text.textContent = message;
    toast.append(dot, text);
    if (action) {
      const link = document.createElement(action.href ? "a" : "button");
      link.className = "toast__action";
      link.textContent = action.label;
      if (action.href) link.href = action.href;
      if (action.onClick) link.addEventListener("click", action.onClick);
      toast.append(link);
    }
    while (region.children.length >= 3) region.firstElementChild.remove();
    region.append(toast);
    let timer;
    const dismiss = () => {
      clearTimeout(timer);
      toast.classList.add("is-leaving");
      toast.addEventListener("transitionend", (() => toast.remove()), {
        once: true
      });
      setTimeout((() => toast.remove()), 600);
    };
    const start = () => timer = setTimeout(dismiss, duration);
    toast.addEventListener("pointerenter", (() => clearTimeout(timer)));
    toast.addEventListener("pointerleave", start);
    start();
  };
  V.openDialog = (id, opener) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    const returnTo = opener && !opener.closest("dialog") ? opener : document.querySelector("dialog[open]:modal")?._opener || opener || document.activeElement;
    document.querySelectorAll("dialog[open]").forEach((other => {
      if (other !== dialog && other.matches(":modal")) {
        other._opener = null;
        other.close();
      }
    }));
    dialog._opener = returnTo;
    dialog.showModal();
    opener?.setAttribute("aria-expanded", "true");
    dialog.dispatchEvent(new CustomEvent("dialog:open", {
      bubbles: true
    }));
  };
  let pressedOn = null;
  document.addEventListener("pointerdown", (event => pressedOn = event.target));
  document.addEventListener("click", (event => {
    const opener = event.target.closest("[data-dialog-open]");
    if (opener) {
      event.preventDefault();
      V.openDialog(opener.dataset.dialogOpen, opener);
      return;
    }
    const closer = event.target.closest("[data-dialog-close]");
    if (closer) {
      closer.closest("dialog")?.close();
      return;
    }
    const target = event.target;
    if (target instanceof HTMLDialogElement && target.open && target.matches(":modal") && pressedOn === target) {
      target.close();
    }
  }));
  document.addEventListener("close", (event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    document.querySelectorAll(`[data-dialog-open="${dialog.id}"]`).forEach((el => el.setAttribute("aria-expanded", "false")));
    if (dialog._opener && document.contains(dialog._opener)) dialog._opener.focus({
      preventScroll: true
    });
  }), true);
  function setCount(selector, value) {
    document.querySelectorAll(selector).forEach((badge => {
      const changed = badge.textContent !== String(value);
      badge.textContent = value;
      badge.hidden = Number(value) === 0;
      if (changed && value > 0) {
        badge.classList.remove("is-bumping");
        void badge.offsetWidth;
        badge.classList.add("is-bumping");
      }
    }));
  }
  const WISHLIST_KEY = "vernika:wishlist";
  V.wishlist = {
    all: () => V.store.get(WISHLIST_KEY, []).filter((h => typeof h === "string")),
    has: handle => V.wishlist.all().includes(handle),
    toggle(handle) {
      const list = V.wishlist.all();
      const index = list.indexOf(handle);
      const added = index === -1;
      if (added) list.unshift(handle); else list.splice(index, 1);
      V.wishlist.save(list);
      return added;
    },
    remove(handle) {
      V.wishlist.save(V.wishlist.all().filter((h => h !== handle)));
    },
    save(list) {
      V.store.set(WISHLIST_KEY, list);
      syncWishlist();
      document.dispatchEvent(new CustomEvent("wishlist:change", {
        detail: {
          handles: list
        }
      }));
    }
  };
  function syncWishlist() {
    const list = V.wishlist.all();
    document.querySelectorAll("[data-wishlist-toggle]").forEach((button => {
      const on = list.includes(button.dataset.handle);
      button.setAttribute("aria-pressed", String(on));
      const label = on ? button.dataset.labelRemove : button.dataset.labelAdd;
      if (label) button.setAttribute("aria-label", label);
    }));
    setCount("[data-wishlist-count]", list.length);
  }
  document.addEventListener("click", (event => {
    const button = event.target.closest("[data-wishlist-toggle]");
    if (!button) return;
    event.preventDefault();
    const added = V.wishlist.toggle(button.dataset.handle);
    button.classList.remove("is-popping");
    void button.offsetWidth;
    if (added) button.classList.add("is-popping");
  }));
  const regionIds = () => [ ...new Set([ ...document.querySelectorAll("[data-cart-region]") ].map((el => el.dataset.cartRegion))) ];
  const onCartPage = () => document.body.classList.contains("template-cart");
  V.cart = {
    drawer: () => document.getElementById("cart-drawer"),
    open() {
      if (!V.cart.drawer() || onCartPage()) {
        if (!onCartPage()) window.location.href = V.routes.cart;
        return;
      }
      V.openDialog("cart-drawer");
    },
    async request(path, payload, render = true) {
      if (render && typeof V.cart.beforeRender === "function") await V.cart.beforeRender();
      const body = {
        ...payload
      };
      if (render) {
        body.sections = regionIds();
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(`${path}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      });
      const data = await response.json().catch((() => ({})));
      if (!response.ok) {
        const error = new Error(data.description || data.message || t("cartError"));
        error.status = response.status;
        throw error;
      }
      if (render) V.cart.apply(data.sections);
      return data;
    },
    apply(sections) {
      if (!sections) return;
      let count;
      const focusedKey = document.activeElement?.closest("[data-cart-key]")?.dataset.cartKey;
      const focusedRegion = document.activeElement?.closest("[data-cart-region]")?.dataset.cartRegion;
      Object.entries(sections).forEach((([id, html]) => {
        if (!html) return;
        const doc = (new DOMParser).parseFromString(html, "text/html");
        const fresh = doc.querySelector(`[data-cart-region="${id}"]`);
        if (!fresh) return;
        if (fresh.dataset.itemCount !== undefined) count = fresh.dataset.itemCount;
        document.querySelectorAll(`[data-cart-region="${id}"]`).forEach((current => {
          const scroller = current.querySelector(".drawer__body");
          const scrollTop = scroller ? scroller.scrollTop : 0;
          current.innerHTML = fresh.innerHTML;
          if (fresh.dataset.itemCount !== undefined) current.dataset.itemCount = fresh.dataset.itemCount;
          const newScroller = current.querySelector(".drawer__body");
          if (newScroller) newScroller.scrollTop = scrollTop;
          if (focusedKey && focusedRegion === id) {
            current.querySelector(`[data-cart-key="${CSS.escape(focusedKey)}"] input`)?.focus({
              preventScroll: true
            });
          }
        }));
      }));
      if (count !== undefined) setCount("[data-cart-count]", Number(count));
      syncWishlist();
      document.dispatchEvent(new CustomEvent("cart:updated", {
        detail: {
          itemCount: count === undefined ? null : Number(count)
        }
      }));
    },
    async refresh() {
      const ids = regionIds();
      if (!ids.length) return;
      const url = new URL(window.location.href);
      url.searchParams.set("sections", ids.join(","));
      const sections = await fetch(url).then((r => r.json()));
      V.cart.apply(sections);
    },
    async add(items, {open: open = true} = {}) {
      const data = await V.cart.request(V.routes.cartAdd, {
        items: items
      });
      if (open && V.cart.drawer() && !onCartPage()) {
        V.cart.open();
      } else {
        V.toast(t("cartAdded"), {
          action: onCartPage() ? undefined : {
            label: t("cartView"),
            href: V.routes.cart
          }
        });
      }
      return data;
    },
    async change(key, quantity) {
      const lines = document.querySelectorAll(`[data-cart-key="${CSS.escape(key)}"]`);
      lines.forEach((line => line.setAttribute("aria-busy", "true")));
      try {
        await V.cart.request(V.routes.cartChange, {
          id: key,
          quantity: quantity
        });
      } catch (error) {
        V.toast(error.message, {
          tone: "error"
        });
        await V.cart.refresh().catch((() => {}));
      } finally {
        lines.forEach((line => line.removeAttribute("aria-busy")));
      }
    },
    async update(payload, {render: render = true} = {}) {
      return V.cart.request(V.routes.cartUpdate, payload, render);
    }
  };
  document.addEventListener("click", (async event => {
    const cartLink = event.target.closest("[data-cart-open]");
    if (cartLink && V.cart.drawer() && !onCartPage()) {
      event.preventDefault();
      V.cart.open();
      return;
    }
    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      event.preventDefault();
      V.cart.change(remove.dataset.cartRemove, 0);
      return;
    }
    const button = event.target.closest("[data-quick-add]");
    if (!button || button.getAttribute("aria-busy") === "true") return;
    event.preventDefault();
    button.setAttribute("aria-busy", "true");
    try {
      await V.cart.add([ {
        id: Number(button.dataset.variantId),
        quantity: 1
      } ]);
    } catch (error) {
      V.toast(error.message, {
        tone: "error"
      });
    } finally {
      button.removeAttribute("aria-busy");
    }
  }));
  const pending = new Map;
  document.addEventListener("input", (event => {
    const line = event.target.closest("[data-cart-key]");
    if (!line || event.target.tagName !== "INPUT") return;
    const key = line.dataset.cartKey;
    clearTimeout(pending.get(key));
    const value = event.target.value.trim();
    if (value === "" || !(Number(value) >= 1)) return;
    pending.set(key, setTimeout((() => {
      pending.delete(key);
      V.cart.change(key, Math.floor(Number(value)));
    }), 350));
  }));
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector("input");
      if (!this.input) return;
      this.addEventListener("click", (event => {
        const step = event.target.closest("[data-qty-step]");
        if (!step) return;
        this.set(Number(this.input.value || 0) + Number(step.dataset.qtyStep));
      }));
      this.input.addEventListener("change", (() => this.set(Number(this.input.value))));
      this.refresh();
    }
    get min() {
      return Number(this.input.min || 1);
    }
    get max() {
      return this.input.max ? Number(this.input.max) : Infinity;
    }
    set(value) {
      const next = Math.min(this.max, Math.max(this.min, Number.isFinite(value) ? value : this.min));
      const changed = next !== Number(this.input.dataset.last ?? this.input.defaultValue);
      this.input.value = next;
      this.input.dataset.last = next;
      this.refresh();
      if (changed) this.input.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    }
    refresh() {
      const value = Number(this.input.value);
      this.querySelector('[data-qty-step="-1"]')?.toggleAttribute("disabled", value <= this.min);
      this.querySelector('[data-qty-step="1"]')?.toggleAttribute("disabled", value >= this.max);
    }
  }
  if (!customElements.get("quantity-input")) customElements.define("quantity-input", QuantityInput);
  const productCache = new Map;
  V.fetchProduct = handle => {
    if (!productCache.has(handle)) {
      const root = V.routes.root.replace(/\/$/, "");
      productCache.set(handle, fetch(`${root}/products/${encodeURIComponent(handle)}.js`).then((r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })));
    }
    return productCache.get(handle);
  };
  V.sizedImage = (src, width) => {
    if (!src) return "";
    const url = new URL(src, window.location.href);
    url.searchParams.set("width", width);
    return url.toString();
  };
  const HEART = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>';
  const BAG_PLUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M12 10v6M9 13h6"/></svg>';
  V.renderCard = p => {
    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const label = (key, title) => (t(key) || "").replace("%TITLE%", title);
    const card = el("article", `card${p.available ? "" : " card--soldout"}`);
    const media = el("div", "card__media");
    const images = (p.images || []).filter(Boolean);
    const main = p.featured_image || images[0];
    if (main) {
      const img = el("img", "card__img");
      img.src = V.sizedImage(main, 700);
      img.alt = "";
      img.loading = "lazy";
      img.width = 700;
      img.height = 875;
      media.append(img);
      if (images[1] && V.cardHoverImage !== false) {
        const alt = el("img", "card__img card__img--alt");
        alt.src = V.sizedImage(images[1], 700);
        alt.alt = "";
        alt.loading = "lazy";
        alt.width = 700;
        alt.height = 875;
        media.append(alt);
      }
    }
    const badges = el("div", "card__badges");
    if (!p.available) badges.append(el("span", "badge badge--soldout", t("soldOut"))); else if (p.compare_at_price > p.price) badges.append(el("span", "badge badge--sale", t("sale")));
    media.append(badges);
    const wish = el("button", "card__wish");
    wish.type = "button";
    wish.dataset.wishlistToggle = "";
    wish.dataset.handle = p.handle;
    wish.dataset.labelAdd = label("wishlistAddLabel", p.title);
    wish.dataset.labelRemove = label("wishlistRemoveLabel", p.title);
    wish.setAttribute("aria-pressed", String(V.wishlist.has(p.handle)));
    wish.setAttribute("aria-label", V.wishlist.has(p.handle) ? wish.dataset.labelRemove : wish.dataset.labelAdd);
    wish.innerHTML = HEART;
    media.append(wish);
    if (p.available) {
      const single = p.variants.length === 1;
      const quick = el(single ? "button" : "a", "card__quick");
      quick.innerHTML = BAG_PLUS;
      quick.append(el("span", "card__quick-label", single ? t("quickAddShort") : t("chooseSize")));
      quick.lastChild.setAttribute("aria-hidden", "true");
      if (single) {
        quick.type = "button";
        quick.dataset.quickAdd = "";
        quick.dataset.variantId = p.variants[0].id;
        quick.setAttribute("aria-label", label("quickAddLabel", p.title));
      } else {
        quick.href = p.url;
        quick.dataset.quickOptions = p.handle;
        quick.setAttribute("aria-haspopup", "dialog");
        quick.setAttribute("aria-label", label("chooseSizeLabel", p.title));
      }
      media.append(quick);
    }
    const info = el("div", "card__info");
    const heading = el("h3", "card__title");
    const link = el("a", "card__link", p.title);
    link.href = p.url;
    heading.append(link);
    const sale = p.compare_at_price > p.price;
    const price = el("div", `price price--sm${sale ? " price--sale" : ""}`);
    price.append(el("span", "price__now", p.price_varies ? (t("priceFrom") || "%PRICE%").replace("%PRICE%", V.money(p.price_min ?? p.price)) : V.money(p.price)));
    if (sale && !p.price_varies) price.append(el("s", "price__was", V.money(p.compare_at_price)));
    info.append(heading, price);
    card.append(media, info);
    return card;
  };
  const quickAdd = {
    dialog: () => document.getElementById("quick-add"),
    async open(handle, opener) {
      const dialog = quickAdd.dialog();
      if (!dialog) return false;
      quickAdd.reset(dialog);
      dialog.dataset.handle = handle;
      V.openDialog("quick-add", opener);
      try {
        const product = await V.fetchProduct(handle);
        if (dialog.open && dialog.dataset.handle === handle) quickAdd.render(dialog, product);
      } catch {
        window.location.href = opener.href;
      }
      return true;
    },
    reset(dialog) {
      dialog.querySelector("[data-qa-title]").textContent = "";
      dialog.querySelector("[data-qa-price]").replaceChildren();
      dialog.querySelector("[data-qa-options]").replaceChildren();
      const img = dialog.querySelector("[data-qa-img]");
      img.hidden = true;
      img.removeAttribute("src");
      dialog.querySelector("[data-qa-skeleton]").hidden = false;
      const add = dialog.querySelector("[data-qa-add]");
      add.disabled = true;
    },
    render(dialog, product) {
      const names = product.options.map((option => typeof option === "string" ? option : option.name));
      const values = names.map(((_, i) => [ ...new Set(product.variants.map((v => v.options[i]))) ]));
      const selected = values.map((list => list.length === 1 ? list[0] : null));
      dialog.querySelectorAll("[data-qa-link]").forEach((link => link.href = product.url));
      dialog.querySelector("[data-qa-title]").textContent = product.title;
      const img = dialog.querySelector("[data-qa-img]");
      if (product.featured_image) {
        img.src = V.sizedImage(product.featured_image, 300);
        img.hidden = false;
        dialog.querySelector("[data-qa-skeleton]").hidden = true;
      }
      const optionsBox = dialog.querySelector("[data-qa-options]");
      const fieldsets = names.map(((name, i) => {
        const fieldset = document.createElement("fieldset");
        fieldset.className = "chips";
        const legend = document.createElement("legend");
        legend.textContent = name;
        fieldset.append(legend);
        values[i].forEach((value => {
          const label = document.createElement("label");
          label.className = "chip";
          const input = document.createElement("input");
          input.type = "radio";
          input.name = `qa-option-${i}`;
          input.value = value;
          input.checked = selected[i] === value;
          input.addEventListener("change", (() => {
            selected[i] = value;
            update();
          }));
          label.append(input, document.createTextNode(value));
          fieldset.append(label);
        }));
        return fieldset;
      }));
      const showOptions = !product.variants.every((v => v.title === "Default Title"));
      optionsBox.replaceChildren(...showOptions ? fieldsets : []);
      const add = dialog.querySelector("[data-qa-add]");
      const priceBox = dialog.querySelector("[data-qa-price]");
      let current = null;
      const update = () => {
        fieldsets.forEach(((fieldset, i) => {
          fieldset.querySelectorAll("label").forEach((label => {
            const value = label.querySelector("input").value;
            const possible = product.variants.some((v => v.available && v.options[i] === value && v.options.every(((o, j) => j === i || selected[j] === null || selected[j] === o))));
            label.classList.toggle("chip--unavailable", !possible);
          }));
        }));
        current = selected.every((s => s !== null)) ? product.variants.find((v => v.options.every(((o, j) => o === selected[j])))) || null : null;
        const shown = current || product.variants.find((v => v.available)) || product.variants[0];
        priceBox.className = `price${shown.compare_at_price > shown.price ? " price--sale" : ""}`;
        const now = document.createElement("span");
        now.className = "price__now";
        now.textContent = V.money(shown.price);
        const parts = [ now ];
        if (shown.compare_at_price > shown.price) {
          const was = document.createElement("s");
          was.className = "price__was";
          was.textContent = V.money(shown.compare_at_price);
          parts.push(was);
        }
        priceBox.replaceChildren(...parts);
        const missing = names.find(((_, i) => selected[i] === null));
        if (missing) {
          add.disabled = true;
          add.textContent = t("quickSelect").replace("%OPTION%", missing.toLowerCase());
        } else if (!current || !current.available) {
          add.disabled = true;
          add.textContent = t("quickUnavailable");
        } else {
          add.disabled = false;
          add.textContent = t("quickAdd").replace("%PRICE%", V.money(current.price));
        }
      };
      add.onclick = async () => {
        if (!current) return;
        add.setAttribute("aria-busy", "true");
        try {
          await V.cart.add([ {
            id: current.id,
            quantity: 1
          } ]);
        } catch (error) {
          V.toast(error.message, {
            tone: "error"
          });
        } finally {
          add.removeAttribute("aria-busy");
        }
      };
      update();
    }
  };
  document.addEventListener("click", (async event => {
    const trigger = event.target.closest("[data-quick-options]");
    if (!trigger || !quickAdd.dialog()) return;
    event.preventDefault();
    await quickAdd.open(trigger.dataset.quickOptions, trigger);
  }));
  V.initScrollers = (scope = document) => {
    scope.querySelectorAll("[data-scroller]:not([data-ready])").forEach((scroller => {
      scroller.dataset.ready = "";
      const track = scroller.querySelector("[data-scroller-track]");
      const prev = scroller.querySelector("[data-scroller-prev]");
      const next = scroller.querySelector("[data-scroller-next]");
      if (!track) return;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      const step = direction => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        track.scrollBy({
          left: direction * track.clientWidth * .9,
          behavior: reduce ? "auto" : "smooth"
        });
      };
      prev?.addEventListener("click", (() => step(-1)));
      next?.addEventListener("click", (() => step(1)));
      track.addEventListener("scroll", update, {
        passive: true
      });
      new ResizeObserver(update).observe(track);
      update();
    }));
  };
  V.initReveal = (scope = document) => {
    const items = scope.querySelectorAll("[data-reveal]:not(.is-revealed)");
    if (!items.length) return;
    if (!("IntersectionObserver" in window) || window.Shopify && Shopify.designMode) {
      items.forEach((el => el.classList.add("is-revealed")));
      return;
    }
    document.documentElement.classList.add("reveal-ready");
    const observer = new IntersectionObserver((entries => {
      entries.forEach((entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      }));
    }), {
      rootMargin: "0px 0px -8% 0px",
      threshold: .05
    });
    items.forEach((el => observer.observe(el)));
  };
  document.addEventListener("shopify:section:load", (event => {
    V.initScrollers(event.target);
    V.initReveal(event.target);
    syncWishlist();
  }));
  V.syncWishlist = syncWishlist;
  document.addEventListener("listing:updated", syncWishlist);
  V.initScrollers();
  V.initReveal();
  syncWishlist();
  window.addEventListener("storage", (event => {
    if (event.key === WISHLIST_KEY) syncWishlist();
  }));
  window.addEventListener("pageshow", (event => {
    if (event.persisted) {
      syncWishlist();
      V.cart.refresh().catch((() => {}));
    }
  }));
})();
